import { colors } from '../constants/colors';
import { getRandomInt } from './numbers';
export const getRandomColor = () => {
  const min = 0;
  const max = colors.length - 1;
  return colors[getRandomInt(min, max)];
};
